import { useState } from 'react';
import { TruncateString } from '../../lib/helpers/StringHelper';
import { ImportStatusSummary } from '../smartsend/SmartSendSocketsModels';
import ImportStatusItemIndicator from './ImportStatusItemIndicator';
import { GetSocketDescription, GetSocketLink, GetSocketLinkText } from './GetSocketDescription';
import Time from '../Time';
import {
  P2GGrid,
  P2GLink,
  P2GText,
  SvgEnquiryExclamation,
  SvgConfirmCircle,
  SvgNotification,
  P2GFade,
  P2GBox,
  P2GAlert
} from '@parcel2go/core-ui';
import ECommerceLogo from '~/apps/account-linking/components/ECommerceLogo';
import CdnIconProxy from '~/apps/account-linking/components/CdnIconProxy';

interface props {
  group: ImportStatusSummary;
}

const ImportStatusItem: React.FC<props> = (props) => {
  const error =
    (props.group.Update?.IsError && props.group.Update) ||
    (props.group.Import?.IsError && props.group.Import) ||
    (props.group.Sync?.IsError && props.group.Sync);

  const latest = props.group.Update || props.group.Import || props.group.Sync;

  const [expand, setExpand] = useState(!!error);

  const toggle = () => setExpand(!expand);

  const link = error
    ? GetSocketLink({
        Code: error.Updates[0].Code,
        MarketplaceSource: error.MarketplaceSource,
        Links: error.Links
      })
    : '';

  return (
    <>
      <P2GGrid container wrap="nowrap" gap={1} alignItems="center" alignContent="center">
        <P2GGrid item flexShrink={1}>
          <ECommerceLogo integration={props.group.MarketplaceSource} style={{ height: '25px' }} />
        </P2GGrid>
        <P2GGrid item flexGrow={1}>
          <P2GLink onClick={toggle}>{TruncateString(props.group.UserId, 20)}</P2GLink>
          <P2GText variant="caption" component="p">
            {latest ? `Completed at ${Time(latest.SentTime)}` : `Your import is queued and will start shortly`}
          </P2GText>
        </P2GGrid>
        {latest ? (
          <P2GGrid item flexShrink={1}>
            {error ? (
              <CdnIconProxy size="sm" palette="error" src="/theme/icons/EnquiryExclamation.svg" onClick={toggle}>
                <SvgEnquiryExclamation />
              </CdnIconProxy>
            ) : (
              <CdnIconProxy size="sm" palette="success" src="/theme/icons/ConfirmSmall.svg" onClick={toggle}>
                <SvgConfirmCircle />
              </CdnIconProxy>
            )}
          </P2GGrid>
        ) : (
          <P2GGrid item flexShrink={1}>
            <CdnIconProxy size="sm" palette="success" src="/theme/icons/Notification.svg" onClick={toggle}>
              <SvgNotification />
            </CdnIconProxy>
          </P2GGrid>
        )}
      </P2GGrid>
      {expand && (
        <P2GFade in={expand} timeout={1000}>
          <P2GBox mt={1}>
            {error ? (
              <P2GAlert palette="error">
                <P2GText variant="body2">{GetSocketDescription(error.Updates[0])}</P2GText>
                {link && (
                  <>
                    <br />
                    <P2GLink href={link}>
                      {GetSocketLinkText({
                        Code: error.Updates[0].Code
                      }) || 'Continue'}
                    </P2GLink>
                  </>
                )}
              </P2GAlert>
            ) : (
              <P2GBox p={1}>
                <P2GGrid container spacing={1} direction="column">
                  <P2GGrid item>
                    <ImportStatusItemIndicator group={props.group.Import}>
                      <P2GText variant="body2">
                        <strong>Importing New Orders</strong>
                      </P2GText>
                    </ImportStatusItemIndicator>
                  </P2GGrid>
                  <P2GGrid item>
                    <ImportStatusItemIndicator group={props.group.Sync}>
                      <P2GText variant="body2">
                        <strong>Removing Cancelled Orders</strong>
                      </P2GText>
                    </ImportStatusItemIndicator>
                  </P2GGrid>
                  {props.group.Update && (
                    <P2GGrid item>
                      <ImportStatusItemIndicator group={props.group.Update}>
                        <P2GText variant="body2">
                          <strong>Tracking Notification Updates</strong>
                        </P2GText>
                      </ImportStatusItemIndicator>
                    </P2GGrid>
                  )}
                </P2GGrid>
              </P2GBox>
            )}
          </P2GBox>
        </P2GFade>
      )}
    </>
  );
};
export default ImportStatusItem;
